var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base_objects',{ref:"base_objects",attrs:{"essence":"ОО","service":_vm.service,"single_element_url":_vm.single_element_url,"with_status_filter":"","with_group":"","without_edit_many":!_vm.check_roles([ 'grouping' ]),"keys_if_all_attrs_hidden":_vm.default_attrs}})
}
var staticRenderFns = []

export { render, staticRenderFns }